<template>
  <div>
    <div
      v-if="areaDeviceData.length > 0"
      class="tree-box-filter forbit-cancel-tree"
    >
      <Input
        v-model="filterText"
        clearable
        type="text"
        size="large"
        maxlength="50"
        :placeholder="
          currentStep === 0
            ? $t('updateNewSip.filter1')
            : $t('updateNewSip.filter2')
        "
      />
      <Button
        type="primary"
        size="large"
        icon="ios-search"
        @click="filterTree"
      ></Button>
    </div>

    <!-- 树形区域组件 -->
    <div class="tree-box">
      <el-tree
        ref="tree"
        size="large"
        :empty-text="filterText.length > 0 ? $t('updateNewSip.noDataTip') : ''"
        :data="treeData"
        :props="props"
        :indent="25"
        node-key="$treeNodeId"
        class="demo-tree-render"
        :highlight-current="true"
        :render-content="renderContent"
        :filter-node-method="filterNode"
        :current-node-key="currentChosenNode"
        :default-expanded-keys="[currentChosenNode]"
        @node-click="selectTree"
      >
      </el-tree>
      <!-- 无区域数据 -->
      <div v-if="areaDeviceData.length === 0" class="no-area">
        <span></span>
        <h4>{{ $t("deviceSip.noArea") }}</h4>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "configTree",
  props: {
    currentStep: {
      type: Number,
      default: 0,
    },
    currentChosenNode: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      filterText: "", // 筛选字段
      currentHeight: 0,
      props: {
        label: "name",
        children: "groupList",
        isLeaf: "leaf",
      },
      treeData: [],
      nodeKey: null, // 选中的节点的唯一标识
      currentContextMenu: {},
      menuVisible: false,
      areaNum: 0,
      deviceNum: 0,
    };
  },
  computed: {
    ...mapState("projectConfig", [
      "areaData",
      "areaDeviceData",
      "addressDeviceList",
      "allDeviceNum",
      "allAreaNum",
    ]),
  },
  watch: {
    filterText(val) {
      if (val.length === 0) {
        this.$refs.tree.filter(val);
      }
    },
  },
  created() {},
  mounted() {
    this.treeData = this.formateArray(this.areaDeviceData);
    this.currentHeight = document.documentElement.clientHeight / 3;
  },
  beforeUpdate() {},
  beforeDestroy() {},
  beforeRouteEnter(to, from, next) {
    next();
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  methods: {
    cancelChosen() {
      // 置空选中节点
      this.$emit("selectTree", {});
      this.$refs.tree.setCurrentKey();
    },
    // 选中树节点
    selectTree(node, i, j) {
      this.menuVisible = false;
      this.$emit("selectTree", node);
    },
    // 格式化数据
    formateArray(array) {
      let _this = this;
      let outsideDevList = [];
      if (Number(this.currentStep) === 1) {
        array = array.filter((item) => !item.isTopDevice);
        outsideDevList = array.filter(
          (item) => item.isTopDevice && item.groupList
        );

        if (outsideDevList.length > 0) {
          // 存在最外围设备组，删除最外围设备组的显示
          let addressDeviceList = outsideDevList[0].groupList;
          this.$store.commit(
            "projectConfig/SET_ADDRESSDEVICELIST",
            addressDeviceList
          );
        }
      }

      // 过滤外层设备组
      for (const item of array) {
        // 区域数量,用来判断上限值，10000
        if (item.code) {
          this.areaNum = this.areaNum + 1;
        }
        // 设备数量,用来判断上限值，10000
        if (item.funList) {
          this.deviceNum = this.deviceNum + 1;
        }

        // 区域： 第2步只显示区域，
        if (Number(this.currentStep) === 1) {
          if (
            Array.isArray(item["groupList"]) &&
            item["groupList"].length > 0
          ) {
            item.groupList = item["groupList"].filter((i) => {
              if (i.code) {
                return i;
              }
            });

            item.groupList = item.groupList.sort((a, b) => {
              return a.code - b.code;
            });
          } else {
            item.groupList = [];
          }
        }

        // 设备： 第3步骤需要显示区域和设备，还有最外围设备组
        if (Number(this.currentStep) === 2) {
          if (this.addressDeviceList.length > 0) {
            // 最外围设备组显示
            let nodeObj = {
              name: this.$t("deviceSip.list"),
              namePath: this.$t("deviceSip.list"),
              title: this.$t("deviceSip.list"),
              isTopDevice: true,
              children: [],
              groupList: this.addressDeviceList,
              expand: true,
              level: 1, // 第一层级
            };
            let hasTopDevice = array.filter((i) => i.isTopDevice);
            if (hasTopDevice.length > 0) {
              array = array.filter((i) => !i.isTopDevice);
            }
            // 设备名称排序-按字符串排序
            nodeObj.groupList = item.groupList.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });
            array.unshift(nodeObj);
            this.$store.commit("projectConfig/SET_ADDRESSDEVICELIST", []);
          }

          if (Array.isArray(item["devList"]) && item["devList"].length > 0) {
            // 设备位于当前节点的子区域下
            if (!item.groupList) {
              item.groupList = [];
            }
            item.groupList = item["devList"].concat(item.groupList);
            let currentAreaList = item.groupList.filter((i) => {
              if (i.code) {
                return i;
              }
            });
            let currentDeviceList = item.groupList.filter((i) => {
              if (i.funList) {
                return i;
              }
            });

            currentAreaList = currentAreaList.sort((a, b) => {
              return a.code - b.code;
            });
            currentDeviceList = currentDeviceList.sort((a, b) => {
              return a.name.localeCompare(b.name);
            });

            currentDeviceList = _this.unique(currentDeviceList); // 过滤重复
            item.groupList = currentDeviceList.concat(currentAreaList);
          }
        }

        if (Array.isArray(item["groupList"]) && item["groupList"].length > 0) {
          this.formateArray(item["groupList"]);
        }
      }
      this.$store.commit("projectConfig/SET_ALLAREANUM", this.areaNum);
      this.$store.commit("projectConfig/SET_ALLDEVICENUM", this.deviceNum);

      console.log("渲染后的数据：this.treeData");
      console.log(array);

      return array;
    },
    unique(arr) {
      // 根据唯一标识id来对数组进行过滤
      const res = new Map();
      return arr.filter(
        (arr) =>
          !res.has(arr["$treeNodeId"] || arr["id"] || arr["name"]) &&
          res.set(arr["$treeNodeId"] || arr["id"] || arr["name"], 1)
      );
    },
    renderContent(h, { node, data, store }) {
      // 区域节点
      if (data.code && data.code >= 0) {
        return (
          <span class="custom-tree-node">
            <span class="area-icon"></span>
            <span>{node.label}</span>
          </span>
        );
      }
      // 最外围设备列表
      if (data.isTopDevice) {
        return (
          <span class="custom-tree-node">
            <span class="device-icon"></span>
            <span>{node.label}</span>
          </span>
        );
      }

      // 设备节点
      if (data.funList && data.funList.length > 0) {
        return (
          <span class="custom-tree-node">
            <span class="device-icon"></span>
            <span>{node.label}</span>
          </span>
        );
      } else if (data.funList && data.funList.length === 0) {
        return (
          <span class="custom-tree-node">
            <span class="device-icon"></span>
            <span>异常设备:{node.label}</span>
          </span>
        );
      }

      // 错误数据，暂时显示默认错误
      if (data.id) {
        return (
          <span class="custom-tree-node">
            数据异常 :<span>{node.label}</span>
          </span>
        );
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 筛选设备、区域名称
    filterTree() {
      this.$refs.tree.filter(this.filterText);
    },
  },
};
</script>
<style lang="scss" scoped>
.demo-tree-render .ivu-tree-title {
  width: 100%;
}
.ivu-tree-context-menu {
  width: 100%;
}
.tree-box {
  width: 100%;
  height: 450px;
  overflow: auto;
}
.tree-box-filter {
  display: flex;
  width: 85%;
  margin-left: 30px;
  margin-bottom: 20px;
  button {
    width: 60px;
  }
}
.no-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 70%;

  span {
    display: block;
    width: 240px;
    height: 160px;
    margin-bottom: 30px;
    background: url("../../../assets/image/projectConfig/noArea.png") repeat
      no-repeat center center;
  }
}
.menu_item {
  text-align: center;
}

.menu {
  height: 30px;
  width: 120px;
  color: #606266;
  position: absolute;
  padding: 0px;
  box-sizing: border-box;
  text-align: center;
  background-color: #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}
</style>
